import '../css/DocumentPrefillMark.css';

// "From your documents": a small ✦ after a label or a name filled from the company documents (kyc-sent),
// shown while the value is unchanged.
export default function DocumentPrefillMark({ show = true }) {
  if (!show) return null;
  return <span className="kycPrefillMark" title="From your documents" aria-label="From your documents" role="img">
    <i className="bi bi-stars" aria-hidden="true" />
  </span>;
}
